module.exports = __webpack_public_path__ + "static/img/背景.ba6b395.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/背景.png
// module id = D8JC
// module chunks = 3